/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BenefitsChartMobile_tradeFirm$ref: FragmentReference;
export type BenefitsChartMobile_tradeFirm = {|
  +rewards: ?{|
    +currentProgram: ?{|
      +programInfo: ?{|
        +code: ?string
      |}
    |}
  |},
  +$refType: BenefitsChartMobile_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BenefitsChartMobile_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rewards",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentProgram",
          "storageKey": null,
          "args": null,
          "concreteType": "ParentProgram",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "programInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b90651d2bead927c850c7de1d7da7201';
module.exports = node;
